export default {
  // Page title
  title: "Balance Analysis",

  // Form related
  chainPlaceholder: "Please select blockchain",
  addressPlaceholder: "Please enter addresses (maximum 50)",
  reset: "Reset",
  query: "Query",

  // Statistics
  totalAccountBalance: "Total blockchain token balance:",
  totalUsdtBalance: "Total USDT token balance:",

  // Table column headers
  serialNumber: "No.",
  blockchain: "Blockchain",
  address: "Address",
  accountBalance: "Blockchain Token Balance (Available)",
  usdtBalance: "USDT Token Balance",
  updateTime: "Update Time",

  // Empty data
  noData: "No data available",

  // Download related
  downloadDetails: "Download Data Details",
  downloadFileName: "Balance Data",

  // Loading text
  loading: "Loading...",

  // Validation and error messages
  pleaseSelectChain: "Please select a blockchain",
  pleaseEnterAddress: "Please enter an address",
  batchQueryLimit:
    "Batch query supports up to 50 addresses from the same blockchain",

  // User guide
  guideStep1:
    "Enter addresses to query balances, supports batch query (up to 50 addresses)",
};
